//TODO: include all action names here later
export enum ChatContextActionNames {
	SET_BOTTOM_LOADING = 'SET_BOTTOM_LOADING'
}
